<template>
  <app-card
    v-bind="$attrs"
    class="v-card--material mt-4"
    :class="{ 'v-card--material--page-actions': !!$slots.headerActions && hasTitle }"
  >
    <v-card-title class="align-start">
      <v-sheet
        :color="color"
        :width="fullHeader ? '100%' : undefined"
        class="overflow-hidden mt-n9 transition-swing v-card--material__sheet"
        elevation="6"
        max-width="100%"
        rounded
      >
        <v-theme-provider
          v-if="hasHeading"
          dark
        >
          <slot name="heading" />

          <div
            v-if="heading"
            class="text-h4 white--text pa-7 v-card--material__title"
          >
            {{ heading }}
          </div>

          <div
            v-if="icon"
            :class="iconSmall ? 'pa-7' : 'pa-8'"
          >
            <v-icon
              :large="!iconSmall"
              v-text="icon"
            />
          </div>
        </v-theme-provider>
      </v-sheet>

      <div
        v-if="hasTitle"
        :class="fullHeader ? 'pt-4' : 'pl-3'"
        class="text-h4 v-card--material__title mt-2"
      >
        <slot name="title" />

        <template
          v-if="title"
          :class="titleColor ? `${titleColor}--text` : ''"
        >
          {{ title }}
        </template>

        <div class="text-subtitle-1 mb-n4">
          <slot name="subtitle" />

          <template v-if="subtitle">
            <span :class="highlightSubtitle ? 'red--text' : null">{{
              subtitle
            }}</span>
          </template>
        </div>
      </div>

      <v-row
        justify="end"
        class="mt-2 mr-2"
      >
        <slot name="headerActions" />
      </v-row>
    </v-card-title>

    <slot />

    <template v-if="$slots.actions">
      <v-divider class="mt-2 mx-4" />

      <v-card-actions class="px-4 text-caption grey--text">
        <slot name="actions" />
      </v-card-actions>
    </template>
  </app-card>
</template>

<script>
  export default {
    name: 'MaterialCard',

    props: {
      color: String,
      fullHeader: Boolean,
      heading: String,
      icon: String,
      iconSmall: Boolean,
      title: String,
      subtitle: String,
      titleColor: String,
      highlightSubtitle: Boolean,
    },

    computed: {
      hasHeading () {
        return !!(this.icon || this.heading || this.$slots.heading)
      },

      hasTitle () {
        return !!(
          this.title ||
          this.subtitle ||
          this.$slots.title ||
          this.$slots.subtitle
        )
      },
    },
  }
</script>

<style lang="sass">
.v-card.v-card--material
  > .v-card__title
    > .v-card--material__title
      flex: 1 1 auto
      word-break: break-word

@media (max-width: 600px)
  .v-card.v-card--material--page-actions
    > .v-card__title
      display: grid
      grid-template-columns: 64px minmax(0, 1fr)
      align-items: center
      gap: 12px
      padding: 16px
      > .v-card--material__sheet
        margin: 0 !important
        width: 64px
        height: 64px
        display: flex
        align-items: center
        justify-content: center
        > div
          padding: 12px !important
      > .v-card--material__title
        margin: 0 !important
        padding: 0 !important
        min-width: 0
        font-size: 14px !important
        line-height: 1.45 !important
      > .row
        grid-column: 1 / -1
        margin: 0 !important
        justify-content: flex-end
        width: 100%
    > .v-card__text
      padding: 12px 16px 16px
</style>
